import { useMediaQuery } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import TextField from "@mui/material/TextField";

import ButtonDesign from "../../ButtonDesign/ButtonDesign";

import "./ContactForm.css";

const ContactForm = () => {
	const { t } = useTranslation();

	const [modal, setModal] = useState(false);
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [subject, setSubject] = useState("");
	const [message, setMessage] = useState("");

	const isMobile = useMediaQuery("(max-width:767px)");
	const isSmallMobile = useMediaQuery("(max-width:389px)");

	const getFormMailLabel = () => {
		if (isSmallMobile) return t("contact.form.mailMobile");
		if (isMobile) return t("contact.form.mailMobile");
		return t("contact.form.mail");
	};

	const getFormAboutLabel = () => {
		if (isSmallMobile) return t("contact.form.subjectMobile");
		if (isMobile) return t("contact.form.subjectMobile");
		return t("contact.form.subject");
	};

	const emailUrl = "https://api.emailjs.com/api/v1.0/email/send";

	const sendEmail = (e) => {
		const data = {
			service_id: process.env.REACT_APP_SERVICE_ID,
			template_id: process.env.REACT_APP_TEMPLATE_ID,
			user_id: process.env.REACT_APP_PUBLIC_KEY,
			accessToken: process.env.REACT_APP_PRIVATE_KEY,
			template_params: {
				name: name,
				subject: subject,
				email: email,
				message: message,
			},
		};

		axios.post(emailUrl, data).then((response) => {
			setModal(true);
		});
	};

	const messageSent = (e) => {
		setModal(false);
	};

	return (
		<div className="contact-form">
			<div className="contact-form-container">
				<div className="contact-form-name">
					<TextField
						className="contact-form-text"
						id="name"
						label={t("contact.form.name")}
						InputLabelProps={{
							style: { color: "#A4A4A4" },
						}}
						InputProps={{ style: { color: "#f9f9f9" } }}
						onChange={(e) => setName(e.target.value)}
					/>
				</div>
				<div className="contact-form-email">
					<TextField
						className="contact-form-text"
						id="email"
						label={getFormMailLabel()}
						InputLabelProps={{
							style: { color: "#A4A4A4" },
						}}
						InputProps={{ style: { color: "#f9f9f9" } }}
						onChange={(e) => setEmail(e.target.value)}
					/>
				</div>
				<div className="contact-form-topic">
					<TextField
						className="contact-form-text-full-width"
						id="reason"
						label={getFormAboutLabel()}
						style={{ marginBottom: "20px" }}
						InputLabelProps={{
							style: { color: "#A4A4A4" },
						}}
						InputProps={{ style: { color: "#f9f9f9" } }}
						onChange={(e) => setSubject(e.target.value)}
					/>
				</div>
				<div className="contact-form-message">
					<TextField
						className="contact-form-text-message"
						id="message"
						label={t("contact.form.message")}
						multiline
						rows={5}
						InputLabelProps={{
							style: { color: "#A4A4A4" },
						}}
						InputProps={{ style: { color: "#f9f9f9" } }}
						onChange={(e) => setMessage(e.target.value)}
					/>
				</div>
				<div className="contact-form-button">
					<ButtonDesign
						data={{
							text: t("contact.button"),
							form: {
								name: name,
								email: email,
								subject: subject,
								message: message,
							},
							dynamic: true,
						}}
						handleClick={sendEmail}
					/>
				</div>
			</div>

			{/* MODAL CONTACT FORM SENT */}
			<div
				className={`contact-sent-card ${modal ? "modal-open" : "modal-close"}`}
			>
				<div className="contact-sent-card-icon">
					<img
						alt="contact-sent"
						src={require("../../../assets/icons/sent.webp")}
						className="contact-sent-card-icon-img"
					/>
				</div>
				<h3>{t("contact.sent.description")}</h3>
				<div>
					<ButtonDesign
						data={{
							text: t("contact.sent.button"),
							dynamic: false,
							styles: { width: "120px", height: "5px" },
							action: "redirect",
							to: " ",
						}}
						handleClick={() => messageSent()}
					/>
				</div>
			</div>
		</div>
	);
};

export default ContactForm;
